/**
 * 统计卡片（监控看板 / 抽查任务两处共用）
 */
import React from 'react';
import {EMPTY_METRIC} from '../utils/metricFormat';
import {Card} from 'antd';

export interface StatCardItem {
    label: string;
    value: string;
    /** 高亮显示（如触发异常数） */
    highlight?: boolean;
}

interface StatCardsProps {
    items: StatCardItem[];
    loading?: boolean;
}

const StatCards: React.FC<StatCardsProps> = ({items, loading}) => {
    return (
        <div className="grid grid-cols-2 gap-3 mb-4 md:grid-cols-4">
            {items.map((item) => (
                <Card key={item.label} size="small" className="shadow-sm">
                    <div className="text-xs text-gray-500">{item.label}</div>
                    {/* 不用骨架屏：卡片只有一个数值，占位块反而比数字本身更抢眼。
                        加载中显示「-」，与指标取不到时的占位一致，高度也恒定不跳动 */}
                    <div className="mt-1 flex h-8 items-center text-2xl font-semibold leading-8">
                        {loading ? (
                            <span className="text-gray-300">{EMPTY_METRIC}</span>
                        ) : (
                            <span className={item.highlight ? 'text-red-600' : 'text-gray-800'}>{item.value}</span>
                        )}
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default StatCards;
